interface Props {
  title: string;
  count?: number | null;
  description?: string;
  right?: React.ReactNode;
}

export function ContentHeader({ title, count, description, right }: Props) {
  return (
    <div className="content-head">
      <div>
        <h1 className="content-title">
          {title}
          {count != null && (
            <span style={{ color: "var(--text-muted)", fontWeight: 500 }}> · {count}</span>
          )}
        </h1>
        {description && <div className="content-sub">{description}</div>}
      </div>
      {right}
    </div>
  );
}
